import { useState, useEffect } from "react";
import { useLoaderData, useParams, Link } from "react-router-dom";
import Select from "react-select";

import { OpcionesEstadosTratamientos } from './OpcionesEstadosTratamientos';

import * as API from "../services/tratamientosAdmin";
import * as APIPACIENTE from "../services/pacientes";
import * as APIPSICOTERAPIA from "../services/psicoterapia";
import * as APINUTRICION from "../services/nutricion";
import * as APIENTRENAMIENTO from "../services/entrenamiento";
import * as APIMINDFULNESS from "../services/mindfulness";

export async function loader({ params }) {
  const token = sessionStorage.getItem("token");

  // Si no hay token, simplemente NO llamamos a la API y retornamos null
  if (!token) {
    return null;
  }
  return API.getTratamientoById(params.tratamientoId);
}

export function TratamientoAdminItem() {
  const tratamiento = useLoaderData();

  const pacienteId = tratamiento.meta?.paciente;
  const [pacienteNiceName, setPacienteNiceName] = useState([]);
  const date = tratamiento.meta?.fecha;
  const estado = tratamiento.meta?.estado;

  const [otrosEstados, setOtrosEstados] = useState({
    psicEstado: "",
    nutrEstado: "",
    entrEstado: "",
    mindEstado: ""
  });
  console.log(otrosEstados);

  const medicoSelected = tratamiento.meta?.medico;
  const psicoHospSelected = tratamiento.meta?.psicohosp;
  const psicologoSelected = tratamiento.meta?.psicologo;
  const nutricionSelected = tratamiento.meta?.nutricion;
  const entrenamientoSelected = tratamiento.meta?.entrenamiento;
  const mindfulnessSelected = tratamiento.meta?.mindfulness;

  // Carga estados de tratamiento de cada grupouseEffect(() => {
    useEffect(() => {
      const loadEstados = async () => {
        try {
          // Realiza todas las llamadas a la API en paralelo
          const [responseEstadoPsic, responseEstadoNutr, responseEstadoEntr, responseEstadoMind] = await Promise.all([
            APIPSICOTERAPIA.getAllPsicoterapiaByTax(tratamiento.id),
            APINUTRICION.getAllNutricionByTax(tratamiento.id),
            APIENTRENAMIENTO.getAllEntrenamientoByTax(tratamiento.id),
            APIMINDFULNESS.getAllMindfulnessByTax(tratamiento.id),
          ]);
          console.log(responseEstadoPsic, responseEstadoNutr, responseEstadoEntr, responseEstadoMind);
    
          // Obtener el meta.psicEstado del objeto con el mayor valor de meta.psicNumses
          const psicEstadoUltimo = responseEstadoPsic.reduce((max, item) => 
            item.meta.psicNumses > max.meta.psicNumses ? item : max, 
            responseEstadoPsic[0] || { meta: { psicEstado: '', psicNumses: -Infinity } }
          ).meta.psicEstado;
    
          // Obtener el meta.nutrEstado del objeto con el mayor valor de meta.nutrNumses
          const nutrEstadoUltimo = responseEstadoNutr.reduce((max, item) => 
            item.meta.nutrNumses > max.meta.nutrNumses ? item : max, 
            responseEstadoNutr[0] || { meta: { nutrEstado: '', nutrNumses: -Infinity } }
          ).meta.nutrEstado;
    
          // Obtener el meta.entrEstado del objeto con el mayor valor de meta.entrNumses
          const entrEstadoUltimo = responseEstadoEntr.reduce((max, item) => 
            item.meta.entrNumses > max.meta.entrNumses ? item : max, 
            responseEstadoEntr[0] || { meta: { entrEstado: '', entrNumses: -Infinity } }
          ).meta.entrEstado;
    
          // Obtener el meta.mindEstado del objeto con el mayor valor de meta.mindNumses
          const mindEstadoUltimo = responseEstadoMind.reduce((max, item) => 
            item.meta.mindNumses > max.meta.mindNumses ? item : max, 
            responseEstadoMind[0] || { meta: { mindEstado: '', mindNumses: -Infinity } }
          ).meta.mindEstado;
    
          setOtrosEstados({
            psicEstado: psicEstadoUltimo,
            nutrEstado: nutrEstadoUltimo,
            entrEstado: entrEstadoUltimo,
            mindEstado: mindEstadoUltimo
          });
        } catch (error) {
          console.error('Error al cargar datos:', error);
          // Maneja el error según tus necesidades
        }
      };
    
      // Llama a la función
      loadEstados();
    }, [tratamiento]);

  // Load Paciente Nice Name
  useEffect(() => {
    const loadPacienteNiceName = async () => {
      // Await make wait until that
      // promise settles and return its result
      const response = await APIPACIENTE.getPacienteByID(pacienteId);

      let pacienteFullName = response.last_name + ", " + response.first_name;

      // After fetching data stored it in posts state.
      setPacienteNiceName(pacienteFullName);
    };

    // Call the function
    loadPacienteNiceName();
  }, [pacienteId]);

  return (
    <>
      <div id='content'>
        {tratamiento.length === 0 ? (
          <div>Cargando...</div>
        ) : (
          <form id='formUpdatelement'>
            <fieldset id='disabledContainer' disabled='disabled'>
            <div className='grid--2col'>
              <div className='field'>
                <label htmlFor='user'>Paciente</label>
                <div className='control'>
                  <input
                    className='input'
                    id='user'
                    required
                    disabled
                    readOnly
                    type='text'
                    value={pacienteNiceName}
                  />
                </div>
              </div>

              <div className='field'>
                <label htmlFor='date'>Fecha</label>
                <div className='control'>
                  <input
                    className='input'
                    id='date'
                    required
                    type='date'
                    value={date}
                    readOnly
                  />
                </div>
              </div>

              
              <div className='field'>
                <label htmlFor='psicologo'>Psicólogos</label>
                <div className='control'>
                  <Select
                    isMulti
                    className='basic-multi-select'
                    classNamePrefix='select'
                    id='psicologo'
                    name='psicologo'
                    placeholder='Seleccionar Especialistas'
                    value={psicologoSelected}
                    isDisabled
                  />
                </div>
              </div>

              <div className='field'>
                  <label htmlFor='psicEstado'>Estado de seguimiento Tratamiento</label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='psicEstado'
                        readOnly
                        name='psicEstado'
                        value={otrosEstados.psicEstado || estado || ''}
                      >
                        <option value='' disabled={otrosEstados.psicEstado !== ''}>Sin datos</option>
                        { OpcionesEstadosTratamientos.map((option) => (
                          <option
                            key={option.value}
                            value={option.value}
                            disabled={option.disabled}
                          >
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

              <div className='field'>
                <label htmlFor='nutricion'>Nutricionistas</label>
                <div className='control'>
                  <Select
                    isMulti
                    className='basic-multi-select'
                    classNamePrefix='select'
                    id='nutricion'
                    name='nutricion'
                    value={nutricionSelected}
                    placeholder='Seleccionar Especialistas'
                    readOnly
                    isDisabled
                  />
                </div>
              </div>

              <div className='field'>
                  <label htmlFor='nutrEstado'>Estado de seguimiento Nutrición</label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='nutrEstado'
                        readOnly
                        name='nutrEstado'
                        value={otrosEstados.nutrEstado}
                      >
                        <option value='' disabled={otrosEstados.nutrEstado !== ''}>Sin datos</option>
                        { OpcionesEstadosTratamientos.map((option) => (
                          <option
                            key={option.value}
                            value={option.value}
                            disabled={option.disabled}
                          >
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                
              <div className='field'>
                <label htmlFor='entrenamiento'>Entrenadores</label>
                <div className='control'>
                  <Select
                    isMulti
                    className='basic-multi-select'
                    classNamePrefix='select'
                    id='entrenamiento'
                    name='entrenamiento'
                    value={entrenamientoSelected}
                    placeholder='Seleccionar Especialistas'
                    readOnly
                    isDisabled
                  />
                </div>
              </div>

              <div className='field'>
                  <label htmlFor='entrEstado'>Estado de seguimiento Entrenamiento</label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='entrEstado'
                        readOnly
                        name='entrEstado'
                        value={otrosEstados.entrEstado}
                      >
                        <option value='' disabled={otrosEstados.entrEstado !== ''}>Sin datos</option>
                        { OpcionesEstadosTratamientos.map((option) => (
                          <option
                            key={option.value}
                            value={option.value}
                            disabled={option.disabled}
                          >
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>


              <div className='field'>
                <label htmlFor='mindfulness'>Mindfulness</label>
                <div className='control'>
                  <Select
                    isMulti
                    className='basic-multi-select'
                    classNamePrefix='select'
                    id='mindfulness'
                    name='mindfulness'
                    value={mindfulnessSelected}
                    placeholder='Seleccionar Especialistas'
                    readOnly
                    isDisabled
                  />
                </div>
              </div>

              <div className='field'>
                  <label htmlFor='mindEstado'>Estado de seguimiento Mindfulness</label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='mindEstado'
                        readOnly
                        name='mindEstado'
                        value={otrosEstados.mindEstado}
                      >
                        <option value='' disabled={otrosEstados.mindEstado !== ''}>Sin datos</option>
                        { OpcionesEstadosTratamientos.map((option) => (
                          <option
                            key={option.value}
                            value={option.value}
                            disabled={option.disabled}
                          >
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>


              <div className='field'>
                <label htmlFor='medico'>Médicos</label>
                <div className='control'>
                  <Select
                    isMulti
                    className='basic-multi-select'
                    classNamePrefix='select'
                    id='medico'
                    name='medico'
                    value={medicoSelected}
                    placeholder='Seleccionar Especialistas'
                    readOnly
                    isDisabled
                  />
                </div>
              </div>

              <div className='field'>
              <label htmlFor='psicohosp'>Psicólogos con acceso temporal Hospital</label>
                <div className='control'>
                  <Select
                    isMulti
                    className='basic-multi-select'
                    classNamePrefix='select'
                    id='psicohosp'
                    name='psicohosp'
                    value={psicoHospSelected}
                    placeholder='Seleccionar Especialistas'
                    readOnly
                    isDisabled
                  />
                </div>
              </div>

            </div>
            </fieldset>
          </form>
        )}
      </div>
      <div id='actions'>
        <Link className='button is-link' to={`edit`}>
          Editar
        </Link>
        <Link
          className='button is-link is-light'
          to={`../pacientes/${pacienteId}`}
        >
          Volver
        </Link>
      </div>
    </>
  );
}
